import { Mixin } from '@lib/trait';
import { Customer } from '@model/Customer';
import { List, Map } from 'immutable';
import { Reducer } from '../../Reducer';
import { ActiveItemFactory } from '../../Traits/ActiveItem';
import {
    simpleOnGetDone,
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateDone,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess,
} from '../../utils';
import * as TYPES from './types';

const DEFAULT_STATE = Map({
    busy: false,
    error: null,
    items: List([]),
    active: null,
    activeError: null,
    item: null,
});

const ActiveItem = ActiveItemFactory({
    DEFAULT_STATE,
    TYPES,
    Model: Customer,
});

export default class CustomersReducer extends Mixin(Reducer, ActiveItem) {
    NAME = 'Customers';

    alias = {
        [TYPES.CUSTOMERS_GET_REQUEST]: 'onGetRequest',
        [TYPES.CUSTOMERS_GET_SUCCESS]: 'onGetSuccess',
        [TYPES.CUSTOMERS_GET_FAIL]: 'onGetFailure',
        [TYPES.CUSTOMERS_GET_DONE]: 'onGetDone',

        [TYPES.CUSTOMER_CREATE_REQUEST]: 'onItemCreateRequest',
        [TYPES.CUSTOMER_CREATE_SUCCESS]: 'onItemCreateSuccess',
        [TYPES.CUSTOMER_CREATE_FAIL]: 'onItemCreateFailure',
        [TYPES.CUSTOMER_CREATE_DONE]: 'onItemCreateDone',

        [TYPES.CUSTOMER_LOAD_REQUEST]: 'onItemLoadRequest',
        [TYPES.CUSTOMER_LOAD_SUCCESS]: 'onItemLoadSuccess',
        [TYPES.CUSTOMER_LOAD_FAIL]: 'onItemLoadFailure',

        [TYPES.CUSTOMER_UPDATE_REQUEST]: 'onItemUpdateRequest',
        [TYPES.CUSTOMER_UPDATE_SUCCESS]: 'onItemUpdateSuccess',
        [TYPES.CUSTOMER_UPDATE_FAIL]: 'onItemUpdateFailure',
        [TYPES.CUSTOMER_UPDATE_DONE]: 'onItemUpdateDone',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetDone = simpleOnGetDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateDone = simpleOnItemUpdateDone(DEFAULT_STATE);

    /**
     * Default store
     * @param state
     * @returns {*|Immutable.Map<any, any>|Immutable.Map<string, boolean>}
     */
    onDefault(state = DEFAULT_STATE) {
        return state;
    }
}
